import { FC, useCallback, useState } from "react";
import { Collapse, Stack, Typography } from "@mui/material";
import { SavingsOpportunity } from "@/services/cloudchipr.api";
import { ResourceDetailsOpportunityRowColumns } from "@/components/pages/common/resource-details/components/content/opportunities-content/components/row-columns/ResourceDetailsOpportunityRowColumns";
import { ResourceDetailsOpportunityRowContent } from "@/components/pages/common/resource-details/components/content/opportunities-content/components/row-content/ResourceDetailsOpportunityRowContent";

interface ResourceDetailsOpportunityRowProps {
  highest?: boolean;
  singleOne?: boolean;
  opportunity: SavingsOpportunity;
}

export const ResourceDetailsOpportunityRow: FC<
  ResourceDetailsOpportunityRowProps
> = ({ opportunity, singleOne, highest }) => {
  const [expanded, setExpanded] = useState(!!singleOne);

  const toggleExpanded = useCallback(() => setExpanded((e) => !e), []);

  return (
    <Stack bgcolor="grey.100" borderRadius={2}>
      <Stack
        p={1.5}
        spacing={1}
        direction="row"
        onClick={toggleExpanded}
        sx={{ cursor: "pointer" }}
      >
        <ResourceDetailsOpportunityRowColumns
          highest={highest}
          expanded={expanded}
          opportunity={opportunity}
        />
      </Stack>

      <Collapse in={expanded}>
        <Stack p={1.5} pt={0.5} spacing={1}>
          <Typography variant="subtitle2">Details</Typography>

          <ResourceDetailsOpportunityRowContent opportunity={opportunity} />
        </Stack>
      </Collapse>
    </Stack>
  );
};
